import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
    title: 'Personal UI',
    attributeName: 'mainhubCustomizationPersonalUI',
    fields: [
        {
            attributeName: 'arrangementBack',
            label: 'Enable Back',
            helpText: 'Enable or disable the back button in the personal UI',
            default: true,
            type: FormInputTypes.CHECKBOX,
        },
        {
            attributeName: 'arrangementTicket',
            label: 'Enable Tickets',
            helpText: 'Enable or disable the tickets section in the personal UI',
            default: true,
            type: FormInputTypes.CHECKBOX,
        },
        {
            attributeName: 'arrangementSettings',
            label: 'Enable Settings',
            helpText: 'Enable or disable the settings section in the personal UI',
            default: true,
            type: FormInputTypes.CHECKBOX,
        },
        {
            attributeName: 'arrangementSettingsLogin',
            label: 'Enable Settings Login',
            helpText: 'Enable or disable the settings login section in the personal UI',
            default: true,
            type: FormInputTypes.CHECKBOX,
        },
        {
            attributeName: 'arrangementSettingsVolume',
            label: 'Enable Settings Volume',
            helpText: 'Enable or disable the settings volume section in the personal UI',
            default: true,
            type: FormInputTypes.CHECKBOX,
        },
        {
            attributeName: 'arrangementSettingsAbout',
            label: 'Enable Settings About',
            helpText: 'Enable or disable the settings about section in the personal UI',
            default: true,
            type: FormInputTypes.CHECKBOX,
        },
        {
            attributeName: 'arrangementMixedReality',
            label: 'Enable Mixed Reality',
            helpText: 'Enable or disable the mixed reality in the personal UI',
            default: true,
            type: FormInputTypes.CHECKBOX,
        },
        {
            attributeName:"sep1",
            type:FormInputTypes.SEPARATOR
        },
        {
            attributeName: 'backButtonIcon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Back Button Icon',
            hasSelect:false,
            helpText: 'The asset to show as back button in the app',
            fileType: ['.png'],  
        },
        {
            attributeName: 'leavePartyButtonIcon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Leave Party Button Icon',
            hasSelect:false,
            helpText: 'The asset to show as leave party button in the app',
            fileType: ['.png'],  
        },
        {
            attributeName: 'separatorIcon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Separator Icon',
            hasSelect:false,
            helpText: 'The asset to show as separator in the app',
            fileType: ['.png'],  
        },
        {
            attributeName: 'socialButtonIcon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Social Button Icon',
            hasSelect:false,
            helpText: 'The asset to show as social button in the app',
            fileType: ['.png'],  
        },
        {
            attributeName: 'settingsButtonIcon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Settings Button Icon',
            hasSelect:false,
            helpText: 'The asset to show as settings button in the app',
            fileType: ['.png'],  
        },
        {
            attributeName: 'ticketButtonIcon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Ticket Button Icon',
            hasSelect:false,
            helpText: 'The asset to show as ticket button in the app',
            fileType: ['.png'],  
        },
        {
            attributeName: 'mixedRealityButtonIcon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Mixed Reality Button Icon',
            hasSelect:false,
            helpText: 'The asset to show as mixed reality button in the app',
            fileType: ['.png'],  
        },
        {
            attributeName: 'virtualRealityButtonIcon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Virtual Reality Button Icon',
            hasSelect:false,
            helpText: 'The asset to show as virtual reality button in the app',
            fileType: ['.png'],  
        },
        {
            attributeName: 'resetUIButtonIcon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Reset UI Button Icon',
            hasSelect:false,
            helpText: 'The asset to show as reset UI button in the app',
            fileType: ['.png'],  
        },
    ]
}